import { useMemo } from 'react'
import { v4 as uuid } from 'uuid'

export default function useUuid(length = 8, deps = []) {
  /*
    eslint-disable-next-line react-hooks/use-memo --

    This utility hook intentionally accepts an optional dynamic dependency array.
    The React Compiler cannot statically analyze this, but it's by design - callers
    can specify when the UUID should regenerate via the deps parameter.
  */
  return useMemo(() => uuid().substring(0, length), deps)
}
